const proxyConsole = window.console;

export async function switchCamera(this: any, { previousFailed } = { previousFailed: false }) {
  const { done, value: deviceIdToUse } = this.devicesIterator.next(previousFailed);

  if (done === true) {
    this.canSwitchCamera = false;

    return;
  }

  this.currentDeviceID = deviceIdToUse;

  const constraints = {
    video: {
      deviceId: deviceIdToUse,
    },
    audio: true,
  };

  this.stopAllTracks();

  try {
    const mediaStream = await navigator.mediaDevices?.getUserMedia(constraints);

    this.mediaStream = mediaStream;
    this.$refs.video.srcObject = mediaStream;
    this.$refs.video.play();

    this.constraints = constraints;
  } catch (error) {
    proxyConsole.error(error);
    await this.switchCamera({ previousFailed: true });
  }
}
